const pages = require('./pages.json');
const origin = 'https://elaritech.com';

function metadata(pathname) {
  let route;
  try { route = decodeURIComponent(pathname).replace(/\/$/, '') || '/'; }
  catch { route = pathname; }
  const page = pages[route];
  const url = new URL(route, origin).href;
  const organization = {
    '@type': 'Organization', '@id': `${origin}/#organization`,
    name: 'ELARITECH', url: `${origin}/`, logo: `${origin}/img/elaritech-logo.jpg`,
    email: 'info@elaritech.com', telephone: '+541161361408',
    sameAs: ['https://www.facebook.com/profile.php?id=61572272330417'],
  };
  return {
    title: page?.title || 'Página no encontrada | ELARITECH',
    description: page?.description || 'La página solicitada no está disponible. Conocé los servicios de desarrollo de ELARITECH.',
    url, image: `${origin}/img/elaritech-logo.jpg`,
    robots: page ? 'index, follow' : 'noindex, follow',
    schema: {
      '@context': 'https://schema.org',
      '@graph': [organization,
        { '@type': 'WebSite', '@id': `${origin}/#website`, url: `${origin}/`, name: 'ELARITECH', inLanguage: 'es-AR', publisher: { '@id': organization['@id'] } },
        { '@type': 'WebPage', '@id': `${url}#webpage`, url, name: page?.title || 'Página no encontrada', description: page?.description, inLanguage: 'es-AR', isPartOf: { '@id': `${origin}/#website` }, about: { '@id': organization['@id'] } },
      ],
    },
  };
}

module.exports = { metadata, pages, origin };
